// extracted by mini-css-extract-plugin
module.exports = {"styled-iframe":"pdf-viewer_styled-iframe__8o38d"};